import { Avatar, Button, Card, Flex, Upload, message, notification } from 'antd'
import React from 'react'
import {
    InboxOutlined,
} from '@ant-design/icons';

const { Dragger } = Upload;


export default function BulkUpload({ fileData, setFileData, fileList = [], setFileList, analyzeStatus = false }) {
    const [api, contextHolder] = notification.useNotification();
    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    const handleBeforeUpload = (file) => {
    const isCSV = file.type === 'text/csv' || file.name.endsWith('.csv');

    if (!isCSV) {
        openNotificationWithIcon('error', "Upload", "You can only upload CSV files!", 'bottomLeft');
        return Upload.LIST_IGNORE; 
    }

    setFileData(file);
    setFileList([file]);
    return false; 
    };


    const handleOnRemove = () => {
        setFileData(null);
        setFileList([])
    };

    return (
        <>
            <div>
                <Dragger
                    accept=".csv"
                    beforeUpload={handleBeforeUpload}
                    multiple={false}
                    maxCount={1}
                    onRemove={handleOnRemove}
                    fileList={fileList}
                    disabled={analyzeStatus}
                >
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                        Supports single or bulk uploads. Uploading sensitive or unauthorized files is strictly prohibited.
                    </p>
                </Dragger>
            </div>
            {contextHolder}

        </>
    )
}
